import { useState, useEffect } from 'preact/hooks';
import Layout from 'utils/layout';

const useResponsive = () => {
  const layout = Layout.getInstance();
  const [breakPoint, setBreakPoint] = useState(layout.isBreakpoint());

  useEffect(() => {
    const resizeHandle = (e) => {
      setBreakPoint(e.detail.bp);
    };
    window.addEventListener('bpChange', resizeHandle);
    return () => {
      window.removeEventListener('bpChange', resizeHandle);
    };
  }, []);

  return { breakPoint, isMobile: !['lg', 'xl', '2xl'].includes(breakPoint) };
};

export default useResponsive;
